import { makeAutoObservable, runInAction } from 'mobx'

import api from 'src/api/global'
import { getMenu } from './utils/function'

interface Options {
  label: string
  value: string | number
}

export interface Dict {
  natLogType?: any
  purchaseOrderType?: any
  purchaseOrderStatus?: any
  popDevType?: any
  privateLineArea?: any
  vlanNetType?: any
  vlanPortMode?: any
  popMachineStatus?: any
  popRunningStatus?: any
  popType?: any
  privateLineType?: any
  routerExecuteResult?: any
  routerDeployResult?: any
  commonModule?: any
  commonFunction?: any
  commonAction?: any
  commonResult?: any
  mobileSupport?: any
  monitorNoticeMode?: any
  aclDirection?: Options[]
  aclProtocol?: Options[]
  aclType?: Options[]
  aclRuleType?: Options[]
  qosRuleType?: Options[]
  cpeStatus?: any
  direction?: any
  dnatMode?: any
  dnatProtocol?: any
  gatewayStatus?: any
  lanMode?: any
  qosProtocol?: any
  ruleType?: any
  serviceProvider?: any
  userRole?: any
  wanMode?: any
  netWorkMode?: any
  monitorGroup?: any
  monitorGroupType?: any
  monitorHealth?: any
  monitorLevel?: any
  monitorMode?: any
  monitorEventStatus?: any
  monitorStatus?: any
  monitorType?: any
  _myDictInfo?: any
  gatewayIsp?: any
  lanDhcpServer?: any
  wifiAuthType?: any
  wifiMode?: any
  mobileStatus?: any
  mobileRunningStatus?: any
  haLinkRunningStatus?: any
  haLinkMode?: any
  networkType?: any
  haLinkStatus?: any
  snatMode?: any
  gatewayAction?: any
  cpeAction?: any
  haDeviceMode?: any
  haDeviceCpeStatus?: any
  gatewayBranchType?: any
  routerProtocol?: any
  snatProtocol?: any
  netTupleProtocol?: any
  dpiType?: any
}

export default class AppStore {
  // 左侧菜单
  public menu = getMenu()

  constructor() {
    makeAutoObservable(this)

    this.getLang()
  }

  dictInfo: Dict = {}
  lang: string = 'zh_CN'
  // 当前选中的key
  defaultMenuKey: string = ''
  // 当前展开的菜单
  openKey: string[] = ['']

  getLang = () => this.lang = window.localStorage.getItem('language') || 'zh_CN'
  // 语言下拉菜单点击触发
  onLangItemClick = (info: any) => {
    if(info.key !== this.lang) {
      window.localStorage.setItem('language', info.key)
      this.getLang()
      window.location.reload()
    }
  }

  // 获取当前路由路径对应的菜单的path
  getPathname = (pathname: string) => {
    this.menu.some((menuItem) => {
      let findItem
      if (menuItem?.children) {
        findItem = menuItem?.children.find((item) => pathname.includes(item.to))
      } else {
        findItem = pathname.includes(menuItem.to) ? menuItem : null
      }
      if (findItem) {
        this.defaultMenuKey = findItem.key
        this.openKey = [menuItem.key]
        return true
      } else {
        this.defaultMenuKey = ''
        return false
      }
    })
  }

  // 设置展开折叠的submenu
  setOpenkey = (openKeys: any[]) => {this.openKey = openKeys}

  // 退出登录
  onSignOut = () => {
    const token = window.localStorage.getItem('sdwan-token') || ''
    window.localStorage.removeItem('sdwan-token')
    api.logout({ token }).then(data => {
      if(data?.url) {
        window.location.href = data?.url
      }
    })
    // window.location.reload()
  }

  getInfo = () => {
    if(window.localStorage.getItem('sdwan-token')) {
      api.getDict().then(result => {

        result._myDictInfo = {}

        // 将字典数组封装成对象
        for (const key in result) {
          if(key !== '_myDictInfo')
            result._myDictInfo[key] = dictFormat(result[key])
        }

        runInAction(() => this.dictInfo = result)
      })
    } else {
      this.dictInfo = { _myDictInfo: {} }
    }
  }

  getMenu = () => {
    window.setMenu && window.setMenu(getMenu(), 'SD-WAN')
  }

  params = () => {
    const url = window.location.hash
    const result: { [key: string]: string } = {}
    const params = url.split('?')[1]

    if(params) {
      params.split('&').forEach(item => {
        const temp = item.split('=')
        result[temp[0]] = temp[1]
      })
    }

    return result
  }

  selectUser = (val: any, option: any) => {
    const { aliasId, auth } = option
    const { menus = [] } = auth
    // 选完下属用户后 更新authId和authMenu
    window.localStorage.setItem('sdwan-authId', aliasId)
    window.localStorage.setItem('sdwan-authMenu', JSON.stringify(menus))
    // 选完用户回到概览页
    window.location.href = `${window.location.origin}/#/sdwan/dashboard/overview`
    window.location.reload()
  }
}

function dictFormat(data: any) {
  const dictValueToLabel = {} as { [value: number]: string } // 对象：键为字典的value 值为字典的label
  const dictLabelToValue = {} as { [label: string]: number } // 对象：键为字典的label 值为字典的value 用于通过value找key

  data.forEach((item: { value: any; label: any }) => {
    dictValueToLabel[item?.value] = item?.label
    dictLabelToValue[item?.label] = item?.value
  })

  return { dictValueToLabel, dictLabelToValue }
}
